import {loginreq,loginInfo, req} from './axiosFun';
export const getLoginQRCode = (params) => { return loginreq("get", "/link/common/getLoginQRCode", params) };
export const getLoginInfo = (params) => { return loginInfo("get", "/link/common/getLoginStatus", params) };
export const loginOut = (params) => { return req("get", "/link/common/loginOut", params) };
export const loginByAccount = (params) => { return req("get", "/link/common/loginByAccount", params) };



// WEBPACK FOOTER //
// ./src/api/common.js